module.exports = __webpack_public_path__ + "img/IMG_6984_L_Foamcore.5c8e18c4.jpg";